import './SectionBasicModule.scss';
// import Swiper core and required modules
import { Navigation, Scrollbar, A11y, Mousewheel } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import ButtonIconGhostSmall from '../../common/ButtonIconGhost/ButtonIconGhostSmall';
import { Icon } from '../../icon/icon';
import { Divider } from 'antd';
import { useRef } from 'react';
import ModuleCard from '../ModuleCard/ModuleCard';
import { useSelector } from 'react-redux';
import { Trans } from 'react-i18next';

const SectionBasicModule = () => {
  const swiperRef = useRef(null);

  const { products } = useSelector(state => state.product);

  return (
    <section className="section-basic-module flex lg:py-[60px] py-[32px] flex-col justify-end items-start lg:gap-[32px] gap-[24px] self-stretch bg-fills-white">
      <div className="lg:px-[80px] md:px-[20px] px-[16px]">
        <span className="lg:h1 text-headline-small !font-bold">
          <Trans
            i18nKey={'Constant.Design furniture that FITS your space.'}
            components={{
              br: <br />,
            }}
          />
        </span>
      </div>
      <div className="flex flex-col items-start gap-[16px] self-stretch">
        <Swiper
          // install Swiper modules
          ref={swiperRef}
          modules={[Navigation, A11y, Scrollbar, Mousewheel]}
          spaceBetween={24}
          slidesPerView={'auto'}
          updateOnWindowResize={true}
          scrollbar={{
            draggable: true,
            el: '.custom-scrollbar',
            dragClass: 'custom-scrollbar-drag',
          }}
          navigation={{
            prevEl: '.custom-swiper-button-prev',
            nextEl: '.custom-swiper-button-next',
          }}
          mousewheel={{
            forceToAxis: true, // chỉ cho cuộn ngang
          }}
        >
          {products.data
            ?.filter(item => item.has_design)
            ?.map((item, i) => {
              return (
                <SwiperSlide
                  key={i}
                  className={`w-fit flex-shrink-0 lg:my-[12px] my-[8px] ${
                    i === 0 && 'lg:ml-[80px] ml-[16px]'
                  }`}
                  style={{ height: 'auto' }}
                >
                  <ModuleCard item={item} />
                </SwiperSlide>
              );
            })}
        </Swiper>
        <div className="container-scrollbar flex justify-end items-center gap-8 self-stretch lg:px-[80px] px-[16px]">
          <div className="custom-scrollbar">
            <div className="custom-scrollbar-drag"></div>
          </div>
          <div className="custom-navigation py-4 px-8 items-center gap-8 rounded-[100px] bg-fills-white">
            <ButtonIconGhostSmall
              icon={<Icon.ICPrev />}
              className="custom-swiper-button-prev"
            />
            <Divider
              type="vertical"
              style={{ margin: 0, background: '#E6E7E7', height: '24px' }}
            />
            <ButtonIconGhostSmall
              icon={<Icon.ICNext />}
              className="custom-swiper-button-next"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionBasicModule;
